module.exports = __webpack_public_path__ + "img/10992167000130.3a7a6b91.png";